import { useCallback, useEffect, useState } from 'react';
export var useCreatableOption = _ref => {
  var _creatableOption$shou;

  var {
    query,
    options,
    creatableOption
  } = _ref;
  var [shouldShowCreatableOption, setShouldShowCreatableOption] = useState(false);
  var [newOption, setNewOption] = useState(null);
  var hasCreatableOption = Boolean(creatableOption);
  var defaultShouldDisplayCreatableOption = useCallback(inputValue => Boolean(inputValue && !options.find(option => inputValue.toLocaleLowerCase() === option.label.toLowerCase())), [options]);
  var shouldDisplayCreatableOption = (_creatableOption$shou = creatableOption === null || creatableOption === void 0 ? void 0 : creatableOption.shouldDisplay) !== null && _creatableOption$shou !== void 0 ? _creatableOption$shou : defaultShouldDisplayCreatableOption; // Show/hide the creatable option.

  useEffect(() => {
    if (hasCreatableOption && shouldDisplayCreatableOption(query !== null && query !== void 0 ? query : '')) {
      setShouldShowCreatableOption(true); // We can pass an empty string here because the user may want to create an option without relying on the new option.

      setNewOption({
        value: (query !== null && query !== void 0 ? query : '').toLocaleLowerCase(),
        label: query !== null && query !== void 0 ? query : ''
      });
    } else {
      setShouldShowCreatableOption(false);
      setNewOption(null);
    }
  }, [hasCreatableOption, query, shouldDisplayCreatableOption]);
  return {
    shouldShowCreatableOption,
    setShouldShowCreatableOption,
    newOption
  };
};
//# sourceMappingURL=useCreatableOption.js.map